import { facilityAdapter, facilityProfileAdapter, userNotesAdapter } from './reducer'

const facilitySelectors = facilityAdapter.getSelectors(state => state.facilities)

const facilityProfileSelectors = facilityProfileAdapter.getSelectors(
  state => state.facilities.facility_profiles
)

export const { selectById: selectFacilityById } = facilitySelectors

export const {
  selectAll: selectFacilityProfiles,
  selectById: selectFacilityProfileById,
} = facilityProfileSelectors

export const { selectAll: selectRelatedFacilities } = facilityAdapter.getSelectors(
  state => state.facilities.related_facilities
)

export const { selectAll: selectRelatedDoctors } = facilityAdapter.getSelectors(
  state => state.facilities.related_doctors
)

export const { selectAll: selectRelatedFacilityProfiles } = facilityAdapter.getSelectors(
  state => state.facilities.related_facility_profiles
)

export const { selectAll: selectAllUserNotes, selectById: selectUserNoteById } =
  userNotesAdapter.getSelectors(state => state.facilities.user_notes)

export const selectUserNotesCount = state => state.facilities.user_notes.count
export const selectUserNotesStatus = state => state.facilities.user_notes.status
export const selectUserNotesCurrentPage = state => state.facilities.user_notes.currentPage
export const selectUserNotesCurrentPageSize = state =>
  state.facilities.user_notes.currentPageSize
